export enum Nationality {
  Mexican = 'mexicano',
}
